import { Box, BoxProps, Divider, Text } from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { FileWithPath } from "react-dropzone";
import { FormSubSectionHeader } from "../../../components/formSubSectionHeader/FormSubSectionHeader";
import { KeywordsUploadBox } from "../../segmentSummaryPage/KeywordsUploadBox";

export type UploadFileType = {
  keywordsExc: FileWithPath[];
  keywordsInc: FileWithPath[];
};

interface KeywordsFileProps {
  // keywordsExcFile: UploadFileType;
  // setKeywordsExcFile: Dispatch<SetStateAction<UploadFileType>>;
  keywordsIncFile: UploadFileType;
  setKeywordsIncFile: Dispatch<SetStateAction<UploadFileType>>;
}

export const KeywordsFile = ({
  // keywordsExcFile,
  // setKeywordsExcFile,
  keywordsIncFile,
  setKeywordsIncFile,
  ...boxProps
}: KeywordsFileProps & BoxProps) => {
  // const setExcFiles = (name: string, files: FileWithPath[]) => {
  //   setKeywordsExcFile((prevFiles) => ({ ...prevFiles, [name]: files }));
  // };

  return (
    <Box bg={"white"} {...boxProps}>
      <FormSubSectionHeader label={"Upload Keywords"} />
      <Divider mt={0} mb={4} />
      <KeywordsUploadBox
        keywordsIncFile={keywordsIncFile}
        setKeywordsIncFile={setKeywordsIncFile}
      />
      <Text fontSize={12} marginTop={2} color={"formLabelText"}>
        {"Each line in the .txt file will be considered a keyword."}
      </Text>
    </Box>
  );
};
